import { toast } from "react-toastify";
import { privateAxios } from "../../../config/apiConfig";
import { DELETE_USER_FAILURE, DELETE_USER_REQUEST, GET_USERS_FAILURE, GET_USERS_REQUEST, GET_USERS_SUCCESS, GET_VISITORS_FAILURE, GET_VISITORS_REQUEST, GET_VISITORS_SUCCESS } from "./ActionType";


export const getUsers = () => async (dispatch) => {
    dispatch({ type: GET_USERS_REQUEST })
    try {
        const { data } = await privateAxios.get(`admin/users`);
        dispatch({ type: GET_USERS_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: GET_USERS_FAILURE, payload: error.message })
    }
}

export const getVisitor = (mode) => async (dispatch) => {
    dispatch({ type: GET_VISITORS_REQUEST })
    try {
        const { data } = await privateAxios.get(`admin/visitors?mode=${mode}`);
        dispatch({ type: GET_VISITORS_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: GET_VISITORS_FAILURE, payload: error.message })
    }
}

export const deleteUser = (userId) => async (dispatch) => {
    dispatch({ type: DELETE_USER_REQUEST })
    try {
        const { data } = await privateAxios.delete(`user/user/${userId}`);
        if (data.status === "SUCCESS") {
            dispatch(getUsers())
            toast.success(data.response)
        } else {
            toast.error(data.response || "Failed to delete user.");
        }

    } catch (error) {
        toast.error(error.response?.data?.response || "An error occurred while deleting the user.")
        dispatch({ type: DELETE_USER_FAILURE, payload: error.message })
    }
}